import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useOktaAuth } from '@okta/okta-react';
import { routes } from 'utils/constants/routes';

import { logout } from '../store/auth/auth.action';
import useClearDbTablePersistence from '../screens/SubscriptionsAndDatabases/Databases/components/DatabasesMain/components/DatabasesTable/hooks/useClearDbTablePersistence';

const useLogOut = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const dispatch = useDispatch();
  const { isAuthenticated: isOktaAuthenticated } = authState || {};
  const { clearTablePersistence } = useClearDbTablePersistence();

  const performLogout = useCallback(
    async ({
      url = '',
      logoutType = 'user'
    }: {
      url?: string;
      logoutType?: string;
    } = {}) => {
      const localOktaTokens = await oktaAuth.tokenManager.getTokens();
      const localTokensLength = Object.keys(localOktaTokens).length;

      oktaAuth?.authStateManager.unsubscribe();

      clearTablePersistence();

      if (isOktaAuthenticated || localTokensLength) {
        if (url !== '') {
          window.sessionStorage.setItem('oktaLogOutRedirect', encodeURIComponent(url));
        }

        await oktaAuth.signOut({
          clearTokensBeforeRedirect: true
        });

        return;
      }

      dispatch(
        logout({
          redirect: url !== '' ? url : routes.login,
          logoutType
        })
      );
    },
    [oktaAuth, isOktaAuthenticated, clearTablePersistence, dispatch]
  );

  return { performLogout, isOktaAuthenticated };
};

export default useLogOut;
